import { render, staticRenderFns } from "./ReleaseNotes.vue?vue&type=template&id=02355f64&scoped=true"
import script from "./ReleaseNotes.vue?vue&type=script&lang=js"
export * from "./ReleaseNotes.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotes.vue?vue&type=style&index=0&id=02355f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02355f64",
  null
  
)

export default component.exports